import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { propArrayShape, propShape } from '../../../helpers/custom-prop-types';
import InputError from '../../Ui/Common/InputError';
const HelpFormFieldCategoryRadio = (props) => {
    const { helpCategories, input, meta } = props;
    const isError = meta.touched && meta.error;
    return (_jsxs(_Fragment, { children: [_jsx("ul", Object.assign({ className: `help_form_categories ${isError ? 'is-warning' : ''}` }, { children: helpCategories.map((v) => (_jsx("li", { children: _jsxs("label", Object.assign({ className: 'wbr' }, { children: [_jsx("input", Object.assign({}, input, { id: `help_category_${v.id}`, type: 'radio', value: v.id })), _jsx("span", { children: v.name })] })) }, v.id))) })), _jsx(InputError, { meta: meta })] }));
};
HelpFormFieldCategoryRadio.propTypes = {
    helpCategories: propArrayShape().isRequired,
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default HelpFormFieldCategoryRadio;
